// The step identifiers shared between the store (WaitingStateStore.currentStepKey),
// the per-group-filtered array in stepsData and TaskStepperView's key lookup.
// 'step-3' / 'step-4' double as the translation-key segments (Steps.3.* / Steps.4.*).
export enum StepKey {
  Step0 = 'step-0', // "Aufnahmefragebogen ausfüllen"
  Step1 = 'step-1', // "Warten auf Zuteilung"
  Step2 = 'step-2', // "Zahlungsbereitschaftsstudie (Teil 1)" — group info + survey-1 button
  StepBdm1 = 'step-bdm1', // "1. Umfrage der Zahlungsbereitschaftsstudie" — thank-you/outcome
  StepBdm2 = 'step-bdm2', // "2. Umfrage der Zahlungsbereitschaftsstudie" — due/thank-you/outcome
  Step3 = 'step-3', // "Langzeitstudie: Zuteilung Studiengruppe"
  Step4 = 'step-4', // "Studienstart" (Gruppe A/B/C)
}

// Translation-key segments (Steps.bdm2.<key>.*) for the BDM2 outcome; the
// backend variant is mapped onto them by BDM2_OUTCOME_STEP_KEY in stepsData.
export type Bdm2Outcome =
  | 'voucher'
  | 'local_no_cash'
  | 'local_cash'
  | 'local_full_product'
  | 'mail_no_cash'
  | 'mail_cash'
  | 'mail_full_product'
  | null;

export type StepDataType = {
  key: StepKey;
  title: JSX.Element | string;
  title_long: string;
  img: string;
  description: JSX.Element | string;
  description_long: JSX.Element | string;
  // Interactive element (e.g. the BDM1 booking button) rendered between the
  // long description and the screen-level bottom action.
  action?: JSX.Element | null;
};
